
// $(document).ready(function () {

//    var text = $(".right-div-discount").text();
//    var text1 =  $(".protection_plan-price").text();
//    var newText = text.replace('$', '');
//    var newText1 = text1.replace('$', '');
//    var result = parseFloat(newText) + parseFloat(newText1);
//    var total = '$' + result.toFixed(2);
//    var total_product = '$' + newText ;
//    $('.total_product-price').html(total_product);

//    $('#protection_plan-checkbox').on('change', function() {
//    if ($(this).prop('checked')) { 
  
  
//        var text = $(".right-div-discount").text();
//    var text1 =  $(".protection_plan-price").text();
//    var newText = text.replace('$', '');
//    var newText1 = text1.replace('$', '');
//    var result = parseFloat(newText) + parseFloat(newText1);
//    var total = '$' + result.toFixed(2);
//    var total_product = '$' + newText ;
//    $(".protection_plan_add_btn").show();
//    $(".protection_plan-desc").slideDown();
//    $('.total_product-price').html(total);
//    $(".right-div").html(total);   
//    $(".More-Details-heading").addClass("heading_detail"); 
//    $(".product_forn-submit-btn").addClass("p_plan_product_s");
//   // $("#product_forn-submit-btn").hide();  
 
//   } else {
//       var text = $(".right-div-discount").text();
//     $(".product_forn-submit-btn").removeClass("p_plan_product_s");
//     $(".product_forn-submit-btn").show();
//     $(".protection_plan_add_btn").hide();
//     $(".More-Details-heading").removeClass("heading_detail"); 
//     $(".protection_plan-desc").slideUp();
//     $('.total_product-price').html(total_product);
//     $(".right-div").html(text);

//   }
//   });
//   $(".protection_plan_add_btn").click(function(){
//   var arr1=[];
//   $(".pplr-wrapper").each(function(){
//    // $(this).hasClass("pplr-dropdown ")    
//    if($(this).hasClass("pplr-dropdown")){
//    var select_dropdown  = $(this).find("select").val();      
//    if(select_dropdown != "" && select_dropdown != "undefined"){
//    arr1.push(select_dropdown);
//    }
//    }
//    else if($(this).hasClass("pplr-text")){
//    var input_value = $(this).find("input").val();
//    if(input_value != "" && input_value != "undefined"){
//    arr1.push(input_value);
//    }
//   }
//   });
//   var arr_length = arr1.length;
//   var wrapper_lenth = $(".pplr-wrapper").length;
//   if(arr_length == wrapper_lenth){
//   // if ( $('.pplr_select ').val() != '' ) {
//      var p_plan_id = $(".gift-product").val(); 
//      var p_plan_q = 1; 
//         $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         dataType: 'json',
//         data: {id:p_plan_id, quantity:p_plan_q},
//         async:false,
//         success:function () { 
//         $("#product_forn-submit-btn").trigger("click")
//         },
//        error:function(){
//        console.log("failed")
//        }
//        }); 
//        }
//        }); 

//   });

$(document).ready(function () {
  var currency_format = $("html").attr("symbol");
var ret = currency_format.replace("{{amount}}",'');
 
if ($(".product-without-discount-price").attr("product-vendor")) {


   var text = $(".product-without-discount-price").text();
   var text1 =  $(".protection_plan-price").text();
   var newText = text.replace(ret, '');
   var newText1 = text1.replace(ret, '');
   var result = parseFloat(newText) + parseFloat(newText1);
   var total = ret + result.toFixed(2);
   var total_product = ret + newText ;
   $('.total_product-price').html(total_product);
   $('#protection_plan-checkbox').on('change', function() {
   if ($(this).prop('checked')) { 
       var text = $(".product-without-discount-price").text();
   var text1 =  $(".protection_plan-price").text();
   var newText = text.replace(ret, '');
   var newText1 = text1.replace(ret, '');
   var result = parseFloat(newText) + parseFloat(newText1);
   var total = ret + result.toFixed(2);
   var total_product = ret + newText ;
         if (ret == "Rs. ") {
   newText = newText.replace(",", "");
   newText1 = newText1.replace(",", "");
    var  result = parseFloat(newText) + parseFloat(newText1);
    // format number to Indian rupee
   let rupee = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
   });
  result =  rupee.format(result);
  result = result.replace("₹","");
var total_product = ret + result ;
   $(".right-div").html(total_product);   
  }
     else{
         $(".right-div").html(total);   
     }
   $(".protection_plan_add_btn").show();
   $(".protection_plan-desc").slideDown();
   $('.total_product-price').html(total);
   // $(".right-div").html(total);   
   $(".More-Details-heading").addClass("heading_detail"); 
   $(".product_forn-submit-btn").addClass("p_plan_product_s");
  // $("#product_forn-submit-btn").hide();  
     // $(".compricew-bt").html(total);
  } else {
      var text = $(".product-without-discount-price").text();
    $(".product_forn-submit-btn").removeClass("p_plan_product_s");
    $(".product_forn-submit-btn").show();
    $(".protection_plan_add_btn").hide();
    $(".More-Details-heading").removeClass("heading_detail"); 
    $(".protection_plan-desc").slideUp();
    $('.total_product-price').html(total_product);
    $(".right-div").html(text);
$(".compricew-bt").html(text);
     
  }
  });
  $(".protection_plan_add_btn").click(function(){
  var arr1=[];
  $(".pplr-wrapper").each(function(){
   // $(this).hasClass("pplr-dropdown ")    
   if($(this).hasClass("pplr-dropdown")){
   var select_dropdown  = $(this).find("select").val();      
   if(select_dropdown != "" && select_dropdown != "undefined"){
   arr1.push(select_dropdown);
   }
   }
   else if($(this).hasClass("pplr-text")){
   var input_value = $(this).find("input").val();
   if(input_value != "" && input_value != "undefined"){
   arr1.push(input_value);
   }
  }
  });
  var arr_length = arr1.length;
  var wrapper_lenth = $(".pplr-wrapper").length;
  if(arr_length == wrapper_lenth){
  // if ( $('.pplr_select ').val() != '' ) {
     var p_plan_id = $(".gift-product").val(); 
     var p_plan_q = 1; 
        $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {id:p_plan_id, quantity:p_plan_q},
        async:false,
        success:function () { 
        $("#product_forn-submit-btn").trigger("click")
        },
       error:function(){
       console.log("failed")
       }
       }); 
       }
       }); 


}
else{
   var text = $(".right-div-discount").text();
   var text1 =  $(".protection_plan-price").text();
   var newText = text.replace(ret, '');
   var newText1 = text1.replace(ret, '');

   var result = parseFloat(newText) + parseFloat(newText1);
   var total = ret + result.toFixed(2);
   var total_product = ret + newText ;
     if (ret == "Rs. ") {
   newText = newText.replace(",", "");
   newText1 = newText1.replace(",", "");
    var  result = parseFloat(newText) + parseFloat(newText1);
    // format number to Indian rupee
let rupee = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
});
  result =  rupee.format(result);
  result = result.replace("₹","");
   var total_product = ret + result ;
     }
   $('.total_product-price').html(total_product);

   $('#protection_plan-checkbox').on('change', function() {
   if ($(this).prop('checked')) { 
       var text = $(".right-div-discount").text();
   var text1 =  $(".protection_plan-price").text();
   var newText = text.replace(ret, '');
   var newText1 = text1.replace(ret, '');
   var result = parseFloat(newText) + parseFloat(newText1);
   var total = ret + result.toFixed(2);
   var total_product = ret + newText ;
    if (ret == "Rs. ") {
   newText = newText.replace(",", "");
   newText1 = newText1.replace(",", "");
    var  result = parseFloat(newText) + parseFloat(newText1);
    // format number to Indian rupee
   let rupee = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
   });
  result =  rupee.format(result);
  result = result.replace("₹","");
var total_product = ret + result ;
   $(".right-div").html(total_product);   
  }
     else{
         $(".right-div").html(total);   
     }
   $(".protection_plan_add_btn").show();
   $(".protection_plan-desc").slideDown();
   $('.total_product-price').html(total);
   $(".More-Details-heading").addClass("heading_detail"); 
   $(".product_forn-submit-btn").addClass("p_plan_product_s");
  // $("#product_forn-submit-btn").hide();  
 
  } else {
      var text = $(".right-div-discount").text();
    $(".product_forn-submit-btn").removeClass("p_plan_product_s");
    $(".product_forn-submit-btn").show();
    $(".protection_plan_add_btn").hide();
    $(".More-Details-heading").removeClass("heading_detail"); 
    $(".protection_plan-desc").slideUp();
    $('.total_product-price').html(total_product);
    $(".right-div").html(text);

  }
  });
  $(".protection_plan_add_btn").click(function(){
  var arr1=[];
  $(".pplr-wrapper").each(function(){
   // $(this).hasClass("pplr-dropdown ")    
   if($(this).hasClass("pplr-dropdown")){
   var select_dropdown  = $(this).find("select").val();      
   if(select_dropdown != "" && select_dropdown != "undefined"){
   arr1.push(select_dropdown);
   }
   }
   else if($(this).hasClass("pplr-text")){
   var input_value = $(this).find("input").val();
   if(input_value != "" && input_value != "undefined"){
   arr1.push(input_value);
   }
  }
  });
  var arr_length = arr1.length;
  var wrapper_lenth = $(".pplr-wrapper").length;
  if(arr_length == wrapper_lenth){
  // if ( $('.pplr_select ').val() != '' ) {
     var p_plan_id = $(".gift-product").val(); 
     var p_plan_q = 1; 
        $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {id:p_plan_id, quantity:p_plan_q},
        async:false,
        success:function () { 
        $("#product_forn-submit-btn").trigger("click")
        },
       error:function(){
       console.log("failed")
       }
       }); 
       }
       }); 





}

});